// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"a805fca1","552":"564b470c"}[chunkId] + ".chunk.css";
};